import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b58211de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_3 = { class: "flex items-center" }

import { PropType, computed } from 'vue'
import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from '@headlessui/vue'
import { CheckIcon, ChevronDownIcon } from '@heroicons/vue/24/solid'
import { ISelectOption } from '@/types/interfaces/common.interface'

interface SelectOptionEmits {
  (e: 'update:modelValue', value: string): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectOption',
  props: {
  modelValue: {
    type: String,
    default: undefined,
  },
  label: {
    type: String,
    default: '',
  },
  options: {
    type: Array as PropType<ISelectOption[]>,
    default: () => [],
  },
  fromLang: {
    type: Boolean,
    default: false,
  },
  byTheme: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit
const selectedValue = computed(() =>
  props.options?.find((option) => option.value === props.modelValue),
)
const selectedLabel = computed(() => selectedValue.value?.label)
const selectedIcon = computed(() => selectedValue.value?.icon)

const updateValue = (event: ISelectOption) => {
  emit('update:modelValue', event.value)
}

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["select-option", [__props.byTheme && 'by-theme']])
  }, [
    _createVNode(_unref(Listbox), {
      modelValue: selectedValue.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((selectedValue).value = $event)),
        updateValue
      ]
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ListboxLabel), { class: "block text-sm font-medium text-gray-700" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.label), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: _normalizeClass(["relative", [__props.fromLang && 'flex']])
        }, [
          _createVNode(_unref(ListboxButton), {
            class: _normalizeClass(["list-box-button", [__props.fromLang && 'from-lang']])
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, [
                (selectedIcon.value)
                  ? (_openBlock(), _createBlock(_component_SvgIcon, {
                      key: selectedIcon.value,
                      class: "mr-1 icon-box",
                      icon: selectedIcon.value,
                      height: "24"
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: _normalizeClass([__props.fromLang ? 'ml-0' : 'ml-3', 'block truncate'])
                }, _toDisplayString(selectedLabel.value), 3)
              ]),
              _createElementVNode("span", _hoisted_2, [
                _createVNode(_unref(ChevronDownIcon), {
                  class: "h-5 w-5 text-gray-400",
                  "aria-hidden": "true"
                })
              ])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_Transition, {
            "leave-active-class": "transition ease-in duration-100",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ListboxOptions), {
                class: _normalizeClass(["list-box-option", [__props.fromLang && 'top-9 md:mt-3']])
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
                    return (_openBlock(), _createBlock(_unref(ListboxOption), {
                      key: `option-${index}`,
                      as: "template",
                      value: option
                    }, {
                      default: _withCtx(({ active, selected }) => [
                        _createElementVNode("li", {
                          class: _normalizeClass([
                  active ? 'text-white bg-yellow-600' : 'list-option-text',
                  'select-none relative py-2 pl-3 pr-9',
                ])
                        }, [
                          _createElementVNode("div", _hoisted_3, [
                            (option.icon)
                              ? (_openBlock(), _createBlock(_component_SvgIcon, {
                                  key: 0,
                                  class: "mr-1 icon-box",
                                  icon: option.icon,
                                  height: "24",
                                  "aria-hidden": "true"
                                }, null, 8, ["icon"]))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", {
                              class: _normalizeClass([
                      selected ? 'font-semibold' : 'font-normal',
                      ' block truncate',
                      __props.fromLang ? 'ml-0' : 'ml-3',
                    ])
                            }, _toDisplayString(option.label), 3)
                          ]),
                          selected
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass([
                    active ? 'text-white' : 'text-yellow-600',
                    __props.fromLang ? 'pr-2' : 'pr-4',
                    'absolute inset-y-0 right-0 flex items-center',
                  ])
                              }, [
                                _createVNode(_unref(CheckIcon), {
                                  class: "h-5 w-5",
                                  "aria-hidden": "true"
                                })
                              ], 2))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          })
        ], 2)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}
}

})